import React from 'react';
import { TriggeredPopup, Button } from '@missionlabs/smartagent-app-components';
import KebabMenuIcon from 'images/icon-kebab-menu.svg';
import './kebab-menu-popup.scss';
import { ClipLoader } from 'react-spinners';
import classnames from 'classnames';

interface Props {
    loading?: boolean;
    closeOnClick?: boolean;
    onOpen?: () => void;
    autoPositioning?: boolean;
    autoPositioningOffset?: number;
    popUpClassName?: string;
    triggerClassName?: string;
    triggerImgSrc?: string;
    triggerTitle?: string;
    isTriggerDisabled?: boolean;
}

const KebabMenuPopup: React.FC<Props> = ({
    children,
    popUpClassName,
    triggerClassName,
    triggerImgSrc,
    triggerTitle,
    isTriggerDisabled,
    loading,
    closeOnClick,
    onOpen,
    autoPositioning,
    autoPositioningOffset,
}) => {
    if (loading) return <ClipLoader size={16} color="#000" />;
    const triggerButtonImgSrc = triggerImgSrc ?? KebabMenuIcon;
    const triggerButtonTitle = triggerTitle ?? 'Actions';
    return (
        <TriggeredPopup
            stopPropagation
            closeOnClick={closeOnClick ?? true}
            closeOnClickOutside
            className={classnames({
                [popUpClassName!]: !!popUpClassName,
                'sa-kebab-menu-popup': true,
            })}
            fromRight
            autoPositioning={autoPositioning}
            autoPositioningOffset={autoPositioningOffset}
            trigger={
                <Button
                    type="button"
                    onMouseUp={onOpen}
                    className={classnames({
                        [triggerClassName!]: !!triggerClassName,
                        'sa-kebab-menu-popup': true,
                    })}
                    title={triggerButtonTitle}
                    disabled={isTriggerDisabled}
                >
                    <img src={triggerButtonImgSrc} alt={triggerButtonTitle} />
                </Button>
            }
        >
            {children}
        </TriggeredPopup>
    );
};

export default KebabMenuPopup;
